import { RootState } from '@client/redux/types';
import { combineReducers } from 'redux';

import { getPlatformJourneyReducer } from '@pegasus/platform-journeys';
import { getOctopusReducer } from '@client/lib/assignments';
import cart, { NAMESPACE as CART_NS } from '@client/lib/cart/redux/reducer';
import mylounge from './modules/mylounge/reducer';
import clientDevice from './modules/clientDevice/reducer';
import customer from './modules/customer/reducer';
import user from './modules/user/reducer';
import flashMessage from './modules/flashMessage/reducer';
import tracking from './modules/tracking/reducer';
import newsletter from './modules/newsletter/reducer';
import filters from './modules/filters/reducer';
import ccfEntries from './modules/ccfEntries/reducer';
import semanticArticles from './modules/semanticArticles/reducer';

export default combineReducers<RootState>({
    ...getOctopusReducer(),
    [CART_NS]: cart,
    clientDevice,
    customer,
    flashMessage,
    mylounge,
    newsletter,
    tracking,
    user,
    filters,
    ccfEntries,
    semanticArticles,
    ...getPlatformJourneyReducer(),
});
